import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { antifragilityEndpoints } from '../../../endpoints/antifragility';
import styles from './AFINotificationBanner.module.scss';

interface AFINotificationBannerProps {
  teamId: string;
  onViewAll: () => void;
}

const AFINotificationBanner: React.FC<AFINotificationBannerProps> = ({
  teamId,
  onViewAll,
}) => {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['afi', 'notifications', teamId],
    queryFn: async () => {
      const { data } = await antifragilityEndpoints.getAFINotifications({ teamId });
      return data;
    },
    enabled: !!teamId,
    retry: false,
  });

  const unreadCount = data?.unreadCount ?? 0;
  const notifications = data?.notifications ?? [];

  if (isLoading || isError || unreadCount === 0) {
    return null;
  }

  const hasCritical = notifications.some(
    (n) => !n.read && n.severity === 'critical'
  );

  return (
    <div
      className={`${styles.banner} ${hasCritical ? styles.critical : styles.warning}`}
      role="alert"
    >
      <span className={styles.icon}>⚠️</span>
      <span className={styles.text}>
        <strong>{unreadCount}</strong> alert AFI attivi
      </span>
      <button className={styles.viewAllBtn} onClick={onViewAll}>
        Vedi tutti →
      </button>
    </div>
  );
};

export default AFINotificationBanner;
